let selectedCompany = null

export default {
  setCompany (company) {
    selectedCompany = company
  },
  getCompany () {
    return selectedCompany
  },
  clearCompany () {
    selectedCompany = null
  }
}
